module.exports = __webpack_public_path__ + "images/emoji/lipstick.cb92879e3243767acb65.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/lipstick.png
// module id = T6M0
// module chunks = 24